module.exports = __webpack_public_path__ + "static/img/butterfly.dcaec8dc.jpg";